import { LeadForm, ApiProvider } from './form-common.js'
import { addressComponentList } from './address.js'

class LeadFormDefault extends LeadForm {
    constructor(config) {
        // Call the parent class constructor
        super(config)
    }

    calcStepProgress(stepSelectedId) {
        let inputValid = 0
        let inputCount = 1

        switch (stepSelectedId) {
            case 'stepZip':
                const inputZip = this.form.querySelector('#zip_code')

                if (inputZip.classList.contains('is-valid')) {
                    inputValid += 1
                }
                break;
            case 'stepAddress':
                const inputAddress = this.form.querySelector('#address')

                if (inputAddress.classList.contains('is-valid')) {
                    inputValid += 1
                }
                break;
            case 'stepContact':
                inputCount = 2

                // first_name
                const inputFirstName = this.form.querySelector('#first_name')

                if (inputFirstName.classList.contains('is-valid')) {
                    inputValid += 1
                }

                // last_name
                const inputLastName = this.form.querySelector('#last_name')

                if (inputLastName.classList.contains('is-valid')) {
                    inputValid += 1
                }
                break;
            case 'stepEmail':
                const inputEmailAddress = this.form.querySelector('#email_address')

                if (inputEmailAddress.classList.contains('is-valid')) {
                    inputValid += 1
                }
                break;
            case 'stepPhone':
                const inputPhone = this.form.querySelector('#phone')

                if (inputPhone !== null && inputPhone.classList.contains('is-valid')) {
                    inputValid += 1
                }
                break;
        }

        return inputValid / inputCount
    }

    // See example on thehomesolarsource.com
    stepShowRules(stepElementKey) {

        // if (getHomeownerValue() === 'No') {
        //     const stepsSkipAsHomeownerNo = getStepsSkipAsHomeownerNo()
        //
        //     const stepFirstId = getStepKeyByID(getFirstElementFromArray(stepsSkipAsHomeownerNo))
        //     const stepLastId = getStepKeyByID(getLastElementFromArray(stepsSkipAsHomeownerNo))
        //
        //     if (stepFirstId === stepSelected) {
        //         return stepLastId + 1
        //     }
        //
        //     if (stepLastId === stepSelected) {
        //         return stepFirstId - 1
        //     }
        // }

        return stepElementKey
    }

    async stepCallback(stepSelectedId) {
        // setLicenseNum(this.config.get('licenseNum.' + stepSelectedId))

        switch (stepSelectedId) {
            case 'stepZip':
                if (this.config.get('hasZipError')) {
                    const stepElement = this.getStepElementByID('stepZip')
                    const zip_code = stepElement.querySelector('#zip_code')

                    this.toggleError(zip_code, stepElement, false, true)
                }
                break
            case 'stepAddress':
                // Check if the script is already present
                const existingScript = document.querySelector('script[src*="maps.googleapis.com"]')

                if (!existingScript) {
                    await loadScript('https://maps.googleapis.com/maps/api/js?key=' + getConfigValue('key.google') + '&libraries=places&callback=addressAutocomplete')
                }

                let inputAddress = this.form.querySelector('#address')
                let inputAddressCheck = this.form.querySelector('#address_check')

                if (!inputAddressCheck.value) {
                    inputAddress.value = ''
                }
                break
            case 'stepEmailPhone':
                this.form.querySelector('#email_address_confirm').remove()
                break
        }
    }

    handleFormSubmit() {
        const formData = new FormData(this.form)

        window.history.pushState({}, null, this.config.get('resultsURL'))

        this.historyStep = -1

        this.toggleElementsBasedOnFormStep(false)

        this.containerForm.remove()

        document.querySelector('#' + this.config.get('containerResultsID')).style.display = 'block'

        // setLicenseNum(this.config.get('licenseNum.thankYou'))

        // Adjust `overlay` display if exist
        this.displayOverlayIfExist(false) // It should be out at this point since this.containerForm has already been removed

        if (getConfigValue('environment') === 'staging') {
            googleTriggerEvent('LeadFormSubmit')
        }


        // Process
        fetch(this.config.get('processURL'), {
            method: 'POST',
            credentials: 'same-origin',
            body: formData,
            mode: 'cors',
            headers: {
                'Accept': 'application/json',
            },
        })
            .then((response) => {
                return response.json()
            })
            .then((response) => {
                if (response.success === false) {
                    debug(response)
                    throw new Error(response.message)
                }

                switch (formData.get('formSource')) {
                    default:
                        loadScript('https://www.chablivoy.com/scripts/sdk/everflow.js').then(async () => {
                            console.log('EF.conversion')

                            // EF.conversion({
                            //     offer_id: 8107,
                            // })
                        })
                        break;
                }
                console.log('Form data were sent with success!')
            })
            .catch((error) => {
                debug(error)
                console.log('Form submission encountered an error!')
            })
    }

    // ----------------------- Step checks ----------------------- //

    async stepZipCheck(stepElement, with_error, with_target) {
        let error = false

        if (with_target == null || with_target === 'zip_code') {
            const zip_code = stepElement.querySelector('#zip_code')

            if (zip_code.value.length !== 5 || zip_code.value === '00000') {
                error = true

                this.toggleError(zip_code, stepElement, false, with_error)
            } else {
                if (with_target == null) {
                    const zipData = await ApiProvider.getZipData(zip_code.value)

                    document.querySelector('#zip_country').value = zipData['country'] ?? ''
                    document.querySelector('#zip_state').value = zipData['state'] ?? ''
                    document.querySelector('#zip_city').value = zipData['city'] ?? ''

                    if (zipData['city'] === '' || zipData['city'] === 'undefined') {
                        error = true

                        this.toggleError(zip_code, stepElement, false, with_error)
                    } else {
                        // Special trigger for autofill scenario
                        const stepAddress = this.getStepElementByID('stepAddress')

                        if (stepAddress) {
                            await this.stepAddressCheck(stepAddress, true)
                        }

                        this.toggleError(zip_code, stepElement, true, with_error)
                    }
                } else {
                    this.toggleError(zip_code, stepElement, true, with_error)
                }
            }
        }

        return error
    }

    async stepAddressCheck(stepElement, with_error) {
        let error = false

        const address = stepElement.querySelector('#address')

        if (address.value.length === 0) {
            error = true
        } else {
            if (this.hasAddressDetails() === false) {
                error = true
            }
        }

        this.toggleError(address, stepElement, !error, with_error)

        return error
    }

    // hasZipAddressDetails = function () {
    //     const zip_country = this.form.querySelector('#zip_country')
    //     const zip_state = this.form.querySelector('#zip_state')
    //     const zip_city = this.form.querySelector('#zip_city')
    //
    //     if (zip_country.value.length > 0 && zip_state.value.length > 0 && zip_city.value.length) {
    //         return true
    //     }
    //
    //     return false
    // }
    //
    // hasGoogleAddressDetails = function () {
    //     const locality = this.form.querySelector('#locality')
    //     const route = this.form.querySelector('#route')
    //
    //     if (locality.value.length > 0 && route.value.length > 0) {
    //         return true
    //     }
    //
    //     return false
    // }

    hasAddressDetails = function () {
        // if (this.hasZipAddressDetails() === false) {
        //     return this.hasGoogleAddressDetails()
        // }

        let inputAddress = this.form.querySelector('#address')
        let inputAddressCheck = this.form.querySelector('#address_check')

        if (inputAddress.value !== inputAddressCheck.value) {
            return false
        }

        return true
    }

    async stepContactCheck(stepElement, with_error, with_target) {
        let error = false

        if (with_target == null || with_target === 'first_name') {
            const first_name = stepElement.querySelector('#first_name')

            if (first_name.value.length < 2 || isAlphaString(first_name.value) === false) {
                error = true

                this.toggleError(first_name, stepElement, false, with_error)
            } else {
                this.toggleError(first_name, stepElement, true, with_error)
            }
        }

        if (with_target == null || with_target === 'last_name') {
            const last_name = stepElement.querySelector('#last_name')

            if (last_name.value.length === 0 || isAlphaString(last_name.value) === false) {
                error = true

                this.toggleError(last_name, stepElement, false, with_error)
            } else {
                this.toggleError(last_name, stepElement, true, with_error)
            }
        }

        return error
    }

    async stepEmailPhoneCheck(stepElement, with_error, with_target, is_step_handle) {
        let error = false

        if (with_target == null || with_target === 'phone') {
            const phone = stepElement.querySelector('#phone')

            if (isPhone(phone.value) === false) {
                error = true

                this.toggleError(phone, stepElement, false, with_error)
            } else {
                if (is_step_handle === true) { // Do phone verification only when button is clicked
                    toggleLoading(phone, true)

                    let is_valid = await ApiProvider.getPhoneData(phone.value)

                    toggleLoading(phone, false)

                    if (is_valid === true) {
                        this.toggleError(phone, stepElement, true, with_error)
                    } else {
                        error = true

                        this.toggleError(phone, stepElement, false, with_error)
                    }
                } else {
                    this.toggleError(phone, stepElement, true, with_error)
                }
            }
        }

        if (with_target == null || with_target === 'email_address') {
            const email_address = stepElement.querySelector('#email_address')

            if (isEmailAddress(email_address.value) === false) {
                error = true

                this.toggleError(email_address, stepElement, false, with_error)
            } else {
                this.toggleError(email_address, stepElement, true, with_error)
            }
        }

        return error
    }

    // ----------------------- Step binds ----------------------- //

    stepZipBind(stepElement) {
        let inputZipCode = stepElement.querySelector('#zip_code')

        inputZipCode.addEventListener('keyup', async (event) => {
            if (keyCodeIgnore(event) === true) {
                return
            }

            event.target.value = event.target.value.slice(0, 5)

            let is_disabled = await this.stepZipCheck(stepElement, false, 'zip_code')

            this.handleStepButtonStatus(stepElement, is_disabled)
        })

        inputZipCode.addEventListener('change', async () => {
            let is_disabled = await this.stepZipCheck(stepElement, false, 'zip_code')

            this.handleStepButtonStatus(stepElement, is_disabled)
        })
    }

    stepContactBind(stepElement) {
        const idsElement = ['first_name', 'last_name']

        // first_name
        let inputFirstName = stepElement.querySelector('#first_name')

        inputFirstName.addEventListener('keydown', (event) => {
            if (event.key === ' ') {
                event.preventDefault()
            }
        })

        inputFirstName.addEventListener('keyup', async (event) => {
            if (keyCodeIgnore(event) === true) {
                return
            }

            await this.stepContactCheck(stepElement, false, 'first_name')

            let is_disabled = this.isValidStep(idsElement) !== true

            this.handleStepButtonStatus(stepElement, is_disabled)
        })

        inputFirstName.addEventListener('change', async () => {
            await this.stepContactCheck(stepElement, false, 'first_name')

            let is_disabled = this.isValidStep(idsElement) !== true

            this.handleStepButtonStatus(stepElement, is_disabled)
        })

        // last_name
        let inputLastName = stepElement.querySelector('#last_name')

        inputLastName.addEventListener('keydown', (event) => {
            if (event.key === ' ') {
                event.preventDefault()
            }
        })

        inputLastName.addEventListener('keyup', async (event) => {
            if (keyCodeIgnore(event) === true) {
                return
            }

            await this.stepContactCheck(stepElement, false, 'last_name')

            let is_disabled = this.isValidStep(idsElement) !== true

            this.handleStepButtonStatus(stepElement, is_disabled)
        })

        inputLastName.addEventListener('change', async () => {
            await this.stepContactCheck(stepElement, false, 'last_name')

            let is_disabled = this.isValidStep(idsElement) !== true

            this.handleStepButtonStatus(stepElement, is_disabled)
        })
    }

    stepAddressBind(stepElement) {
        let inputAddress = stepElement.querySelector('#address')

        inputAddress.addEventListener('keydown', async (event) => {
            if (keyCodeIgnore(event) === true) {
                return
            }

            // Reset address inputs
            for (const addressComponent in addressComponentList) {
                this.form.querySelector('#' + addressComponent).value = ''
            }

            let is_disabled = await this.stepAddressCheck(stepElement, false)

            this.handleStepButtonStatus(stepElement, is_disabled)
        })

        inputAddress.addEventListener('change', async () => {
            let is_disabled = await this.stepAddressCheck(stepElement, false)

            this.handleStepButtonStatus(stepElement, is_disabled)
        })

        // Catching custom event dispatched via `addressAutocomplete`
        inputAddress.addEventListener('address_change', async () => {
            let is_disabled = await this.stepAddressCheck(stepElement, false)

            this.handleStepButtonStatus(stepElement, is_disabled)
        })
    }

    stepEmailPhoneBind(stepElement) {
        let idsElement = ['phone', 'email_address']

        // phone
        let inputPhone = stepElement.querySelector('#phone')

        inputPhone.addEventListener('keydown', async (event) => {
            if (!upKeyCodePhone(event)) {
                event.preventDefault()
            }
        })

        inputPhone.addEventListener('keyup', async (event) => {
            if (formatKeyCodePhone(event)) {
                formatToPhone(event)

                await this.stepEmailPhoneCheck(stepElement, false, 'phone')

                let is_disabled = this.isValidStep(idsElement) !== true

                this.handleStepButtonStatus(stepElement, is_disabled)
            }
        })

        inputPhone.addEventListener('change', async (event) => {
            formatToPhone(event)

            await this.stepEmailPhoneCheck(stepElement, false, 'phone')

            let is_disabled = this.isValidStep(idsElement) !== true

            this.handleStepButtonStatus(stepElement, is_disabled)
        })

        // email
        let inputEmailAddress = stepElement.querySelector('#email_address')

        inputEmailAddress.addEventListener('keyup', async (event) => {
            if (keyCodeIgnore(event) === true) {
                return
            }

            await this.stepEmailPhoneCheck(stepElement, false, 'email_address')

            let is_disabled = this.isValidStep(idsElement) !== true

            this.handleStepButtonStatus(stepElement, is_disabled)
        })

        inputEmailAddress.addEventListener('change', async () => {
            await this.stepEmailPhoneCheck(stepElement, false, 'email_address')

            let is_disabled = this.isValidStep(idsElement) !== true

            this.handleStepButtonStatus(stepElement, is_disabled)
        })
    }

    // ----------------------- Step saves ----------------------- //

    stepZipSave(stepElement) {
        const zip_code = stepElement.querySelector('#zip_code').value

        setCookie('form_zip_code', zip_code)
    }
}

const setupForm = function (config) {
    new LeadFormDefault(config)
}

export default setupForm
